module.exports = __webpack_public_path__ + "static/img/one.94320f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/2/one.png
// module id = c3qz
// module chunks = 1